import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    Sidebar,
    Title,
    SubTitle,
    NotYourRepInfo,
    Logo,
    LegalInfoWrapper,
    SidebarDescription
} from '../Shared/Sidebar';
import LegalInfo from '../Widget/LegalInfo';
import { FindRepLink } from '../../containers/DefaultStyles/Details';
import { RTVLogo } from '../../containers/DefaultStyles/Shared';
import { triggerFindYourRep } from '../../containers/LocalRep/actions';
import { StatesAbbreviation } from '../../utils/enums';

const VoteRegistrationSidebar = props => (
    <Sidebar>
        <Logo src={RTVLogo} width={85} />
        {props.loadRep && <Title>{props.fullState}</Title>}
        <SubTitle>
            {props.title} {props.loadRep && props.postalCode}
        </SubTitle>
        {props.description && (
            <SidebarDescription>{props.description}</SidebarDescription>
        )}
        {props.showChangeLocationLink && (
            <NotYourRepInfo>
                <FindRepLink onClick={props.triggerFindYourRep}>Change Location</FindRepLink>
            </NotYourRepInfo>
        )}
        {!props.isMobileResolution && (
            <LegalInfoWrapper showReceiveUpdates={props.showReceiveUpdates}>
                <LegalInfo />
            </LegalInfoWrapper>
        )}
    </Sidebar>
);

VoteRegistrationSidebar.propTypes = {
    description: PropTypes.string,
    fullState: PropTypes.string,
    postalCode: PropTypes.string.isRequired,
    isMobileResolution: PropTypes.bool,
    showChangeLocationLink: PropTypes.bool,
    triggerFindYourRep: PropTypes.func,
    title: PropTypes.string,
    loadRep: PropTypes.bool,
    showReceiveUpdates: PropTypes.bool
};

export default connect(
    state => {
        return {
            fullState:
                StatesAbbreviation[
                    state.cachedFormData.stateId ||
                        state.widget.endUserLocation.region ||
                        null
                ] || '',
            postalCode: `(${state.cachedFormData.postalCode ||
                (state.localRep.localRepData.address || {}).zipCode ||
                state.widget.endUserLocation.postalCode ||
                ''})`,
            isMobileResolution: state.widget.isMobileResolution
        };
    },
    {
        triggerFindYourRep
    }
)(VoteRegistrationSidebar);
